import React from 'react';
import styles from './styles.module.scss';

const FormButton = ({ 
  label,
  onClick,
  type = 'submit',
  variant = 'submit',
  size = 'medium',
  disabled = false,
  loading = false,
  icon,
  iconPosition = 'left',
  width = '100%',
  maxWidth,
  className = ''
}) => {
  // Build class string manually
  let buttonClasses = `${styles.btn} ${styles[`btn--${variant}`]} ${styles[`btn--${size}`]}`;
  
  if (disabled) buttonClasses += ` ${styles['btn--disabled']}`;
  if (loading) buttonClasses += ` ${styles['btn--loading']}`;
  if (className) buttonClasses += ` ${className}`;

  const buttonStyle = {
    width,
    maxWidth,
  };

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || loading}
      style={buttonStyle}
      aria-busy={loading}
    >
      {loading && <span className={styles.spinner} aria-hidden="true" />}
      {!loading && icon && iconPosition === 'left' && (
        <span className={styles.iconLeft}>{icon}</span>
      )}
      <span className={styles.label}>{label}</span>
      {!loading && icon && iconPosition === 'right' && (
        <span className={styles.iconRight}>{icon}</span>
      )}
    </button>
  );
};

export default FormButton;